module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"thumbnails_title":"此商品的其他評論"}}')
  delete Component.options._Ctor
}
